import { createAction } from "@reduxjs/toolkit";
import { IUser } from "./types";

export const toggleTheme = createAction<void>("user/toggleTheme");
export const setUser = createAction<IUser>("user/save");
export const setEventName = createAction<string>("user/eventname");
export const setUserBalance = createAction<number>("user/balance");
